import * as Schema from "effect/Schema";
import { ProjectId, TrimmedNonEmptyString } from "./baseSchemas.js";
/**
 * A file of the message's project, addressed by a hosted path or a stable link.
 * The project is named separately because either link form carries no project
 * segment, and a workspace root is any folder the user picked.
 */
export const OpenArtifactInput = Schema.Union([
    Schema.Struct({ projectId: ProjectId, path: TrimmedNonEmptyString }),
    Schema.Struct({ projectId: ProjectId, linkId: TrimmedNonEmptyString }),
]);
export class ExternalLauncherError extends Schema.TaggedError()("ExternalLauncherError", {
    message: Schema.String,
    cause: Schema.optional(Schema.Defect()),
}) {
}
